export default [
  {
    name: 'login',
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ './pages/Login')
  },
  {
    name: 'sso',
    path: '/sso',
    component: () => import(/* webpackChunkName: "sso" */ './pages/SsoAuth')
  }
]
